/**
 * Base URL for the Cloudflare Image Transformations zone.
 *
 * Read once at module load. If missing we still want to surface the
 * misconfiguration loudly (a silent fallback to root-relative
 * `/cdn-cgi/image/...` URLs loads against the current page host and breaks
 * images), but WITHOUT taking the whole app down: this module is imported by
 * the main bundle, so a top-level `throw` white-screens the entire portal
 * before React renders anything. So:
 *   - dev: throw, so a broken `.env` fails immediately (Vite shows the error).
 *   - prod: log an error and fall back to a root-relative base — broken images
 *     are recoverable; a blank white screen is not.
 */
const value: string = import.meta.env.VITE_MEDIA_BASE_URL ?? "";

if (!value) {
  const message =
    "VITE_MEDIA_BASE_URL is not set — copy apps/seller/.env.example into apps/seller/.env";
  if (import.meta.env.DEV) {
    throw new Error(message);
  }
  console.error(
    `${message}. Falling back to root-relative image URLs; images may fail to load.`,
  );
}

export const MEDIA_BASE_URL = value;
